(() => {
  $('[data-action="delete"]').on('click', function (event) {
    Swal.fire({
      title: "Tem certeza?",
      text: "Você irá excluir este registro.",
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Sim, excluir!",
      cancelButtonText: "Cancelar",
      closeOnConfirm: false
    }).then(function (result) {
      if (result.value) {
        event.target.querySelector('form').submit()
      }
    })
  })

  $('[data-target="confirm-action"]').on('click', function () {
    let title = $(this).data('swal-title')
    let text = $(this).data('swal-text')
    let callback = $(this).data('swal-callback')

    Swal.fire({
      title: title,
      text: text,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Sim, apagar!",
      cancelButtonText: "Cancelar"
    }).then(function (result) {
      if (result.value) {
        setTimeout(callback, 1)
      }
    })
  })
})()
